import React from "react";
import {
  Button,
  Fab,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  TextField,
  withStyles,
} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import { green } from "@material-ui/core/colors";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import CheckIcon from "@material-ui/icons/Check";
import SearchIcon from "@material-ui/icons/Search";
import { differenceInCalendarDays, format, isValid, parseISO, subDays } from "date-fns";
import api from "../../service/api";
import AddDialogForm from "./AddDialogForm";
import RequestAuditAdmin from "./Audit/requestAuditAdmin";
import DataRanger from "./DataRanger/DataRanger";
import DialogAttachament from "./DialogAttachment";
import DialogShare from "./DialogShare";
import Logs from "./Logs";
import Table from "./Table";

const MAX_DAYS_RANGE = 40;

class Forms extends React.Component {
  constructor(props) {
    super(props);
    const today = format(new Date(), "yyyy-MM-dd");
    this.initialDate = today;

    this.state = {
      unidades: [],
      addForm: false,
      addAttach: false,
      addShare: false,
      viewLog: false,
      viewAudit: false,
      form_id: props.form_id,
      form_layout_json: [],
      id_data_form: null,
      fromDate: today,
      toDate: today,
      data_filter: "",
      export: null,
      loading: false,
      success: false,
      is_editable: null,
    };
    this.myRef = React.createRef();
  }

  // normalizeDateRange = (fromDate, toDate) => {
  //   const today = format(new Date(), "yyyy-MM-dd");
  //   let safeToDate = toDate;
  //   let safeFromDate = fromDate;

  //   const parsedToDate = parseISO(safeToDate);
  //   if (!safeToDate || !isValid(parsedToDate)) {
  //     safeToDate = today;
  //   }

  //   const parsedFromDate = parseISO(safeFromDate);
  //   if (!safeFromDate || !isValid(parsedFromDate)) {
  //     safeFromDate = safeToDate;
  //   }

  //   if (safeFromDate > safeToDate) {
  //     const temp = safeFromDate;
  //     safeFromDate = safeToDate;
  //     safeToDate = temp;
  //   }

  //   const rangeInDays = differenceInCalendarDays(
  //     parseISO(safeToDate),
  //     parseISO(safeFromDate)
  //   );

  //   if (rangeInDays > MAX_DAYS_RANGE) {
  //     safeFromDate = format(subDays(parseISO(safeToDate), MAX_DAYS_RANGE), "yyyy-MM-dd");
  //   }

  //   return { fromDate: safeFromDate, toDate: safeToDate };
  // };

  searchForms = () => {
    // const normalizedRange = this.normalizeDateRange(this.state.fromDate, this.state.toDate);
    this.setState(
      // {
      //   fromDate: normalizedRange.fromDate,
      //   toDate: normalizedRange.toDate,
      // },
      () => {
        if (this.myRef.current) {
          this.myRef.current.searchForms(
            this.state.data_filter,
            this.state.fromDate,
            this.state.toDate
          );
        }
      }
    );
  };

  handleCloseSaveFile = (file) => {
    this.setState({
      addForm: false,
      addAttach: false,
      id_data_form: null,
      addShare: false,
    });
    if (this.myRef.current) {
      this.myRef.current.addFiles(file);
    }
  };

  handleCloseSave = () => {
    this.setState({
      addForm: false,
      addAttach: false,
      id_data_form: null,
      addShare: false,
    });
    if (this.myRef.current) {
      this.myRef.current.getDataForms();
    }
  };

  handleCloseSaveMonitor = () => {
    if (this.myRef.current) {
      this.myRef.current.setMonitor(this.state.id_data_form);
    }
    this.setState({
      addForm: false,
      addAttach: false,
      id_data_form: null,
      addShare: false,
    });
  };

  handleCloseSaveVerificador = () => {
    if (this.myRef.current) {
      this.myRef.current.setVerificador(this.state.id_data_form);
    }
    this.setState({
      addForm: false,
      addAttach: false,
      id_data_form: null,
      addShare: false,
    });
  };

  onClickData = (inicio, fim) => {
    this.setState({
      fromDate: inicio === "Invalid date" ? "" : inicio,
      toDate: fim === "Invalid date" ? "" : fim,
    });
  };

  handleCloseFile = () => {
    this.setState({ addAttach: false, id_data_form: null });
    if (this.myRef.current) {
      this.myRef.current.removeRows();
    }
  };

  handleChangeFilter = (event) => {
    this.setState({ data_filter: event.target.value });
  };

  handleClickExport = (event) => {
    this.setState({ export: event.currentTarget });
  };

  handleCloseExport = () => {
    this.setState({ export: null });
  };

  downloadBlob = (blobData, fileName, mimeType = "") => {
    const blob = mimeType ? new Blob([blobData], { type: mimeType }) : new Blob([blobData]);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };

  handleClickExportCsv = () => {
    // const normalizedRange = this.normalizeDateRange(this.state.fromDate, this.state.toDate);

    this.setState({
      loading: true,
      // fromDate: normalizedRange.fromDate,
      // toDate: normalizedRange.toDate,
    });

    api
      .get("/api/report/csv", {
        baseURL: process.env.REACT_APP_BPF_SERVER_URL,
        params: {
          start: this.state.fromDate,
          end: this.state.toDate,
          form: this.state.form_id,
        },
      })
      .then((resp) => {
        this.downloadBlob(
          resp.data,
          `relatorio-${this.state.fromDate}-${this.state.toDate}.csv`,
          "text/csv;charset=utf-8;"
        );
        this.setState({ export: null, loading: false });
      })
      .catch(() => {
        this.setState({ export: null, loading: false });
      });
  };

  handleClickExportJson = () => {
    // const normalizedRange = this.normalizeDateRange(this.state.fromDate, this.state.toDate);

    this.setState({
      loading: true,
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
    });

    api
      .get("/api/report/json", {
        baseURL: process.env.REACT_APP_BPF_SERVER_URL,
        params: {
          start: this.state.fromDate,
          end: this.state.toDate,
          form: this.state.form_id,
        },
      })
      .then((resp) => {
        const jsonString = JSON.stringify(resp.data, null, 2);
        this.downloadBlob(
          jsonString,
          `relatorio-${this.state.fromDate}-${this.state.toDate}.json`,
          "application/json"
        );
        this.setState({ export: null, loading: false });
      })
      .catch(() => {
        this.setState({ export: null, loading: false });
      });
  };

  handleOpenAddForm = () => {
    this.setState({ addForm: true });
  };

  handleOpenAttach = (id) => {
    this.setState({ addAttach: true, id_data_form: id });
  };

  handleEdit = (id, is_editable) => {
    this.setState({ addForm: true, id_data_form: id, is_editable });
  };

  handleOpenShare = () => {
    this.setState({ addShare: true });
  };

  handleOpenLogs = (id) => {
    this.setState({ viewLog: true, id_data_form: id });
  };

  handleOpenAudit = (id) => {
    this.setState({ viewAudit: true, id_data_form: id });
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <IconButton
          aria-label="delete"
          form_id={this.state.form_id}
          className={classes.margin}
          size="large"
          onClick={this.props.close}
        >
          <ArrowBackIcon fontSize="inherit" />
        </IconButton>
        <Paper style={{ margin: "5px" }}>
          {this.state.addForm && (
            <AddDialogForm
              form_id={this.state.form_id}
              id_data_form={this.state.id_data_form}
              is_editable={this.state.is_editable}
              handleCloseSave={this.handleCloseSave}
              handleCloseSaveMonitor={this.handleCloseSaveMonitor}
              handleCloseSaveVerificador={this.handleCloseSaveVerificador}
              handleClose={() => this.setState({ addForm: false, id_data_form: null })}
              name={this.props.labelForm}
            />
          )}
          {this.state.addAttach && (
            <DialogAttachament
              form_id={this.state.form_id}
              id_data_form={this.state.id_data_form}
              handleCloseSave={this.handleCloseSaveFile}
              handleClose={this.handleCloseFile}
            />
          )}
          {this.state.addShare && (
            <DialogShare
              form_id={this.state.form_id}
              handleCloseSave={this.handleCloseSave}
              handleClose={() => this.setState({ addShare: false })}
            />
          )}
          {this.state.viewLog && (
            <Logs
              data_form={this.state.id_data_form}
              handleClose={() => this.setState({ viewLog: false, id_data_form: null })}
            />
          )}
          {this.state.viewAudit && (
            <RequestAuditAdmin
              dataFormId={this.state.id_data_form}
              handleClose={() => this.setState({ viewAudit: false })}
              handleCloseSave={() => this.setState({ viewAudit: false, id_data_form: null })}
            />
          )}
          <div className={classes.divFormSearch}>
            <div className={classes.dataranger}>
              <DataRanger onClick={this.onClickData} />
            </div>
            <div>
              <TextField
                label={"Filtro"}
                value={this.state.data_filter}
                className={classes.textField}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={this.handleChangeFilter}
              />
            </div>
            <div className={classes.root}>
              <div className={classes.wrapper}>
                <Fab
                  aria-label="search"
                  color="primary"
                  type="submit"
                  size="small"
                  onClick={this.searchForms}
                >
                  {this.state.success ? <CheckIcon /> : <SearchIcon />}
                </Fab>
                {this.state.loading && (
                  <CircularProgress size={48} className={classes.fabProgress} />
                )}
              </div>
            </div>
          </div>
        </Paper>
        <div>
          <Table
            add={this.handleOpenAddForm}
            attach={this.handleOpenAttach}
            edit={this.handleEdit}
            share={this.handleOpenShare}
            logs={this.handleOpenLogs}
            audit={this.handleOpenAudit}
            form_id={this.state.form_id}
            ref={this.myRef}
            name={this.props.labelForm}
            initialFromDate={this.initialDate}
            initialToDate={this.initialDate}
            fromDate={this.state.fromDate}
            toDate={this.state.toDate}
          />
        </div>
        <div className={classes.containerExport}>
          <Button
            aria-controls="export-menu"
            disabled={
              this.state.fromDate === "Invalid date" ||
              this.state.fromDate === "" ||
              this.state.toDate === "Invalid date" ||
              this.state.toDate === ""
            }
            variant="contained"
            color="primary"
            aria-haspopup="true"
            onClick={this.handleClickExport}
          >
            Exportar
          </Button>
          <Menu
            id="export-menu"
            anchorEl={this.state.export}
            keepMounted
            open={Boolean(this.state.export)}
            onClose={this.handleCloseExport}
          >
            <MenuItem onClick={this.handleClickExportJson}>JSON</MenuItem>
            <MenuItem onClick={this.handleClickExportCsv}>CSV</MenuItem>
          </Menu>
        </div>
      </div>
    );
  }
}

const styles = (theme) => ({
  typegraphy: {
    backgroundColor: "#0078F0",
    color: "#fff",
    borderRadius: "4px",
    padding: "5px",
    textAlign: "center",
    fontStretch: "semi-condensed",
    fontSize: "16px",
  },
  divFormSearch: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    margin: "2px",
  },
  divNovoExame: {
    display: "flex",
    marginBottom: "10px",
    marginTop: "10px",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
  },
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  wrapper: {
    margin: theme.spacing(1),
    position: "relative",
    display: "flex",
  },
  buttonSuccess: {
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[700],
    },
  },
  fabProgress: {
    color: green[500],
    position: "absolute",
    top: -4,
    left: -4,
    zIndex: 1,
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -15,
    marginLeft: -15,
  },
  dataranger: {
    textAlign: "center",
  },
  containerExport: {
    padding: "5px",
    justifySelf: "self-end",
  },
});

export default withStyles(styles)(Forms);
